const headerNavbar = {
  'headerNavBar-navLink1': 'Sobre nosotros',
  'headerNavBar-navLink2': 'Nuestra oferta',
  'headerNavBar-navLink4': 'Catering',
  'headerNavBar-navLink5': 'Ubicaciones',
  'headerNavBar-navLink6': 'Tienda en línea',
  'headerNavBar-navLink7': 'Socios',
  'headerNavBar-navLink8': 'Admin'
};

export default headerNavbar;
